import './About.css';

const About = () => {
    return (
        <section className="yk-about-section">
            <div className="yk-about-grid">

                {/* ── Image Column ── */}
                <div className="yk-about-image-col">
                    <img
                        src="https://stssevastorage.blob.core.windows.net/ykwebsite/resource/featured-image-6.jpg"
                        alt="Yugal Kunj Temple, Duluth GA"
                    />

                    {/* Caption overlay */}
                    <div className="yk-about-caption">
                        <p className="yk-about-caption-title">Change Your Thoughts, Change Your Life</p>
                        <p className="yk-about-caption-text">
                            "Inspiring selfless devotion to God as taught by the timeless Vedas and Hindu Scriptures and helping community members of all ages to lead a happy, healthy and spiritually oriented life."
                        </p>
                    </div>
                </div>

                {/* ── Content Column ── */}
                <div className="yk-about-content-col">
                    <div className="yk-about-inner">

                        {/* Ornament */}
                        <div className="yk-about-ornament">
                            <div className="yk-about-ornament-line"></div>
                            <div className="yk-about-ornament-dot"></div>
                            <span className="yk-about-ornament-label">Radha Madhav Society</span>
                        </div>

                        {/* Heading */}
                        <h2 className="yk-about-heading">Welcome To Yugal Kunj</h2>

                        {/* Divider */}
                        <div className="yk-about-divider"></div>

                        {/* Description */}
                        <p className="yk-about-text">
                            Radha Madhav Society is part of the worldwide mission of Jagadguru Kripalu Parishat (JKP), a non-profit organization founded by Jagadguru Shree Kripalu ji Maharaj to provide a deeper understanding of true Hinduism and bring to light the wonderful resources of this eternal religion and its all-encompassing culture. The temple is an initiative of Sushri Siddheshvari Devi (Didi Ji), a senior disciple of Shri Jagadguru Shri Kripalu Ji Maharaj, who is well-known to the local Atlanta population as well as a respected figure in the US, Canada, Trinidad and other parts of the world.
                        </p>

                        {/* Read More */}
                        <a href="/USA/about" className="yk-about-readmore">
                            Read More
                            <span className="yk-about-readmore-arrow">→</span>
                        </a>

                        {/* Temple Hours */}
                        <div className="yk-about-hours">
                            <div className="yk-about-hours-label">Temple Hours</div>

                            <div className="yk-about-hours-row">
                                <div className="yk-about-hours-icon">
                                    <span className="fa fa-clock"></span>
                                </div>
                                <span className="yk-about-hours-text">
                                    Mon – Fri &nbsp;|&nbsp; 7:00 AM – 8:00 AM &nbsp;&amp;&nbsp; 5:00 PM – 8:00 PM
                                </span>
                            </div>

                            <div className="yk-about-hours-row">
                                <div className="yk-about-hours-icon">
                                    <span className="fa fa-clock"></span>
                                </div>
                                <span className="yk-about-hours-text">
                                    Sat – Sun &nbsp;|&nbsp; 7:00 AM – 8:00 PM
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default About;